import { render } from "./FormPhone.vue?vue&type=template&id=c3365f12&ts=true"
import script from "./FormPhone.vue?vue&type=script&lang=ts"
export * from "./FormPhone.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__